<template>
  <div class="font2">
      <v-stepper  v-model="e1">
    <v-stepper-header>
      <v-stepper-step
        :complete="e1 > 1"
        step="1"
      >
       Household Info
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        :complete="e1 > 2"
        step="2"
      >
        Location
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">
        Preview
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card
          class="mb-12"
        
          height="200px"
        >
        <!-- Card start -->
        
             <!-- City or zipcode -->
           
     

    <!-- HOusehold number -->
    <v-row class="animate__animated animate__fadeIn animate_slower"  no-gutters align="center" justify="center">
      <v-col cols="12" xl="2" lg="2">
        <p class="text-right font-weight-bold mr-2" style="color:#052542">Household Number</p>
      </v-col>
      <v-col cols="12" xl="10" lg="10">
         <v-radio-group
      v-model="row"
      dense
      class="mt-n1 #052542--text"
      
      row
    
    >
      <v-radio
        label="1"
        value="1"
      ></v-radio>
      <v-radio
        label="2"
        value="2"
      ></v-radio>
      <v-radio
        label="3"
        value="3"
      ></v-radio>
      <v-radio
        label="4"
        value="4"
      ></v-radio>
      <v-radio
        label="5"
        value="5"
      ></v-radio>
    </v-radio-group>
          
      </v-col>
    </v-row>
    

    <!-- yEARLY INCOME -->
     <v-row class="animate__animated animate__fadeIn animate_slower"  no-gutters align="center" justify="center">
      <v-col cols="12" xl="2" lg="2">
        <p class="text-right font-weight-bold mr-2" style="color:#052542">Yearly Income</p>
      
       
      </v-col>
      <v-col cols="12" xl="10" lg="10">
        <v-text-field type="number" v-model="income" aria-required="true" :error="income==0" :error-messages="income==0?'Input an amount':''" error-count="2" outlined dense placeholder="required"  color="#052542"></v-text-field>
          
      </v-col>
    </v-row>

    <!-- Card End -->
        </v-card>

        <v-btn
          color="black"
          dark
          @click="income>0 && row!=''?e1 = 2:''"
        >
          Next
        </v-btn>

        
      </v-stepper-content>

      <v-stepper-content step="2">
         <v-card
          class="mb-12"
         
          height="200px"
        >
        <!-- Card start -->
        
             <!-- City or zipcode -->
           
      <v-row class="animate__animated animate__fadeIn animate_slower"   no-gutters align="center" justify="center">
      <v-col cols="12" xl="2" lg="2">
        <p class="text-right font-weight-bold mr-2" style="color:#052542">State</p>
      
       
      </v-col>
      <v-col cols="12" xl="10" lg="10">
        <!-- <v-text-field type="number" required placeholder="required" outlined dense color="#052542"></v-text-field> -->
         <v-select
          :items="items"
          item-text="state_name"
          item-value="state_code"
          v-model="state"
          @input="listCounty"
          :error="state===''"
          :error-messages="state==''?'Select a state':'' "
          label=""
          dense
          outlined
        ></v-select>
          
      </v-col>
    </v-row>
  
     <v-row class="animate__animated animate__fadeIn animate_slower"   no-gutters align="center" justify="center">
      <v-col cols="12" xl="2" lg="2">
        <p class="text-right font-weight-bold mr-2" style="color:#052542">County</p>
      
       
      </v-col>
      <v-col cols="12" xl="10" lg="10">
        <!-- <v-text-field type="number" required placeholder="required" outlined dense color="#052542"></v-text-field> -->
         <v-select
          :items="county"
          item-text="county_name"
          item-value="fips_code"
          v-model="county_code"
          :disabled="state==''?true:false"
          label=""
          :error="county_code==''"
          :error-messages="state==''?'Select a county':'' "
          dense
          outlined
        ></v-select>
          
      </v-col>
    </v-row>

   

    <!-- Card End -->
        </v-card>

        <v-btn
          color="black"
          dark
          @click="getCountyName"
        >
          Next
        </v-btn>

        <v-btn @click="e1=1" text>
          Previous
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card
          class="mb-12"
          
          height="200px"
        >
        <p class="text-h5 text-center">Preview</p>
        <!-- <p class="text-caption text-center">Confirm all inputs are correct before submitting</p> -->
        <br>
        <v-row class="ml-2" no-gutters justify="center" align="center">
            <v-col cols="4">
              <p><span class="text-caption font-weight-bold">HouseHold</span> <span class="text-caption ml-2">{{row}}</span></p>
            </v-col>
          
           <v-col cols="4">
              <p><span class="text-caption font-weight-bold">Income</span> <span class="text-caption ml-2">${{income}}</span></p>
           </v-col>
            
           <v-col cols="4">
               <p><span class="text-caption font-weight-bold">State code</span> <span class="text-caption ml-2">{{state}}</span></p>
            </v-col>
        </v-row>

        <v-row class="ml-2" no-gutters align="center" justify="center">
          <v-col cols="4">
            <p><span class="text-caption text-left font-weight-bold">State</span> <span class="text-caption ml-2">{{pcountry}}</span></p>
          </v-col>
           
            <v-col cols="4">
              <p><span class="text-caption font-weight-bold">County</span> <span class="text-caption ml-2">{{pcounty}}</span></p>
            </v-col>
            <v-col cols="4">
                <p><span class="text-caption font-weight-bold">County code</span> <span class="text-caption ml-2">{{county_code}}</span></p>
            </v-col>
            
          
        </v-row>
        <v-row no-gutters class="ml-2">
           <v-col cols="4"> 
                <p v-if="eligible=='No'"><span class="text-caption font-weight-bold">Eligible</span> <span class="text-caption red--text ml-2">{{eligible}}</span></p>
                 <p v-else><span class="text-caption font-weight-bold">Eligible</span> <span class="text-caption ml-2">{{eligible}}</span></p>
            </v-col>
        </v-row>
        
        </v-card>

        <v-btn
          color="primary"
          @click="process"
         
        >
          Submit
        </v-btn>

        <v-btn @click="e1=2" text>
          Previous
        </v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>



  <!-- dialog box for fail -->
  <v-dialog
      v-model="dialog"
      width="500"
    >
     

      <v-card>
       
       <div class="pa-9">
        <p class="text-center animate__animated animate__fadeIn animate_slower"> <v-icon class="text-center" size="120" color="red darken-1">mdi-backspace-reverse</v-icon></p>
           <v-card-text class="font-weight-bold text-center grey--text animate__animated animate__fadeIn animate_slower">
          You are below the requirement
        </v-card-text>
       </div>
      </v-card>
    </v-dialog>

<!-- {{housingmetro}} -->
    <!--  Tables -->
    <br>
    <br>
    <div v-if="hideme==false">
      <p class="text-h6 text-center font-weight-bold">{{pcounty}},{{state}}</p>
    <p class="text-center">FY 2021 Income Limits Summary</p>
    <div style="height:40vh;overflow-y:scroll" >
      <v-simple-table>
        <thead>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </thead>
        <tbody>
        <tr>
          <td>Median Income: ${{meridian['median_income']}}</td>
          <td></td>
            <td></td>
              <td></td>
        </tr>
      </tbody>
      </v-simple-table>
      <v-simple-table>
    <template v-slot:default>
      
      <thead>
        <tr>
          <th class="text-left">
            No of persons
          </th>
          <th class="text-left">
            Extremely Low
          </th>
          <th class="text-left">
            Very Low
          </th>
          <th class="text-left">
            Low
          </th>
         
        </tr>
      </thead>
      <tbody>
       
        <tr
          v-for="item in housingmetro"
          :key="item.name"
        >
          <td>{{ item.id}}</td>
          <td>${{ item.extremely_low }}</td>
          <td>${{ item.very_low }}</td>
          <td>${{ item.low }}</td>
        
        </tr>

      </tbody>
    </template>

  </v-simple-table>

 
    </div>
      <br>
  <br>
    <p class="text-center">Final FY 2021 FMRs By Unit Bedrooms</p>
     <v-simple-table>
    <thead></thead>
    <tbody>
        <tr
        >
        <td>Efficiency</td>
          <td>{{ fmrmetro["Efficiency"]}}</td>
          <td></td>
          <td></td>
         
        </tr>
        <tr
        >
        <td>One Bedroom</td>
          <td>{{ fmrmetro["One-Bedroom"]}}</td>
          <td></td>
          <td></td>
         
        </tr>
        <tr
        >
        <td>Two Bedroom</td>
          <td>{{ fmrmetro["Two-Bedroom"]}}</td>
          <td></td>
          <td></td>
         
        </tr>
        <tr
        >
        <td>Three Bedroom</td>
          <td>{{ fmrmetro["Three-Bedroom"]}}</td>
          <td></td>
          <td></td>
         
        </tr>
        <tr
        >
        <td>Four Bedroom</td>
          <td>{{ fmrmetro["Four-Bedroom"]}}</td>
          <td></td>
          <td></td>
         
        </tr>
      </tbody>
  </v-simple-table>
    </div>
  <!-- Table 2 -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return {
             e1: 1,
             items:[],
             state:"",
             county:[],
             county_code:"",
             income:0,
             row:"",
             limit_info:[],
             limit_data:[],
             dialog:false,
             pcountry:"",
             pcounty:"",
             eligible:"-",
             btndisable:true,
             housingmetro:[],
             fmrmetro:[],
             hideme:true,
             meridian:[]
        }
    },
    methods:{
        listCounty(){
           this.county=[]
           for(var i=0;i<this.items.length;i++){
              if(this.items[i].state_code==this.state){
                this.pcountry=this.items[i].state_name
              }
           }


         axios.post("https://housing-match-server.herokuapp.com/county",{
             state_code:this.state
         }).then(res=>{
                this.county=res.data
            }).catch(err=>{
                console.log(err)
            })  
        },
        process(){
            
             
           
       
              axios.post("https://housing-match-server.herokuapp.com/il",{
             county_code:this.county_code
            
         }).then(res=>{
                this.limit_info=res.data
                console.log(res.data)
                this.limit_data=res.data.data
                var fOne="il50_p"+this.row
                // var fTwo="il30_p"+this.row
                var fThree="il80_p"+this.row

                let el1=this.limit_data.very_low[fOne]
                // let el2=this.limit_data.extremely_low[fTwo]
                let el3=this.limit_data.low[fThree]
                console.log(el1)
                
                if(this.income>=el1 && this.income<=el3){
                 
                  this.$router.push("/c/affordable-housing-locator")
                }else{
                  
                   // dialog shows
                     this.dialog=true
                }
                
                
            }).catch(err=>{
                console.log(err)
            })   
            
        },
        getCountyName(){
          this.hideme=false
          this.loadFmr()
          this.loadHousing()
          for(var j=0;j<this.county.length;j++){
            if(this.county_code==this.county[j].fips_code){
              this.pcounty=this.county[j].county_name
              console.log(this.county[j].county_name)
            }
          }
          axios.post("https://housing-match-server.herokuapp.com/il",{
             county_code:this.county_code
            
         }).then(res=>{
                this.limit_info=res.data
                console.log(res.data)
                this.limit_data=res.data.data
                var fOne="il50_p"+this.row
                // var fTwo="il30_p"+this.row
                var fThree="il80_p"+this.row

                let el1=this.limit_data.very_low[fOne]
                // let el2=this.limit_data.extremely_low[fTwo]
                let el3=this.limit_data.low[fThree]
                console.log(el1)
                console.log(el3)
                console.log(typeof el3)
                
                if(this.income>el1 && this.income<el3){
                 this.btndisable=false
                  this.eligible="Yes"
                }else{
                  
                   // dialog shows
                     this.btndisable=true
                  this.eligible="No"
                
                }
                
                
            }).catch(err=>{
                console.log(err)
            }) 
            if(this.state=='' ||this.county_code==''){
              console.log('nana')
            }else{
                 this.e1=3
            } 
         
        },
        loadHousing(){
          axios.post('https://housing-match-server.herokuapp.com/il',{
            county_code:this.county_code
          }).then(res=>{
            console.log(res.data)
             this.meridian=res.data.data
            let newArr=[]
            newArr.push({id:1,very_low:res.data.data.very_low.il50_p1,extremely_low:res.data.data.extremely_low.il30_p1,low:res.data.data.low.il80_p1})
            newArr.push({id:2,very_low:res.data.data.very_low.il50_p2,extremely_low:res.data.data.extremely_low.il30_p2,low:res.data.data.low.il80_p2})
            newArr.push({id:3,very_low:res.data.data.very_low.il50_p3,extremely_low:res.data.data.extremely_low.il30_p3,low:res.data.data.low.il80_p3})
            newArr.push({id:4,very_low:res.data.data.very_low.il50_p4,extremely_low:res.data.data.extremely_low.il30_p4,low:res.data.data.low.il80_p4})
            newArr.push({id:5,very_low:res.data.data.very_low.il50_p5,extremely_low:res.data.data.extremely_low.il30_p5,low:res.data.data.low.il80_p5})
            newArr.push({id:6,very_low:res.data.data.very_low.il50_p6,extremely_low:res.data.data.extremely_low.il30_p6,low:res.data.data.low.il80_p6})
            newArr.push({id:7,very_low:res.data.data.very_low.il50_p7,extremely_low:res.data.data.extremely_low.il30_p7,low:res.data.data.low.il80_p7})
            newArr.push({id:8,very_low:res.data.data.very_low.il50_p8,extremely_low:res.data.data.extremely_low.il30_p8,low:res.data.data.low.il80_p8})
            this.housingmetro=newArr
            console.log(newArr)
          })
        },
        loadFmr(){
          axios.post('https://housing-match-server.herokuapp.com/fmr',{county_code:this.county_code}).then(res=>{
           
              this.fmrmetro=res.data.data.basicdata
          })
        }
    },
    mounted(){
         axios.get("https://housing-match-server.herokuapp.com/states").then(res=>{
                this.items=res.data
            }).catch(err=>{
                console.log(err)
            })
    }
}
</script>

<style>
.font2{
  font-family: 'Ubuntu', sans-serif;
}
</style>